module.exports = __webpack_public_path__ + "static/media/expad-arrows.f345af17.svg";